import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { AppleApplication } from '@rocksoft/mdm-sdk-v2';

import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppleApplicationsService } from '../../../shared/services/apple-application.service';

@Component({
  selector: 'ml-remove-application-modal',
  templateUrl: './remove-application-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, FormsModule, FaIconComponent],
})
export class RemoveApplicationModalComponent {
  private readonly appleApplicationService = inject(AppleApplicationsService);
  public readonly modal = inject(NgbActiveModal);

  public app: AppleApplication;

  public readonly removeAllForm: UntypedFormControl = new UntypedFormControl(false);

  public onSubmit(): void {
    this.appleApplicationService.deleteApplication(
      this.app.bundleIdentifier,
      this.removeAllForm.value ? '' : this.app.bundleVersion
    );
    this.removeAllForm.reset();
    this.modal.close();
  }
}
